<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label" />
            <div class="dx-field-value divide-y">
                <div class="text-2xl">Получатель</div>
                <div />
            </div>
        </div>
    </div>
</template>
<script setup></script>
